import React from "react";
import "./LoadingAnimation.css"; // Make sure to define your CSS styles for LoadingAnimation in a separate file

const LoadingAnimation = () => {
  return (
    <div className="loading-animation">
      <div className="loader"></div>
    </div>
  );
};

export default LoadingAnimation;
